import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBoardComponent } from './side-board.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [SideBoardComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    DragDropModule,
  ],
  exports: [SideBoardComponent],
})
export class SideBoardModule {}
